import { render, staticRenderFns } from "./RequestStatistics.vue?vue&type=template&id=0422363e&"
import script from "./RequestStatistics.vue?vue&type=script&lang=js&"
export * from "./RequestStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports